import React from "react";

export default function SectorAllocationPopUp({ data, onClose }) {
  return (
    <div className="overlay-notification">
    <div className="modal fade show border-0" style={{ display: 'block',cursor:"default" }} tabIndex="-1" role="dialog">
    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div className="modal-content">
            <div className="modal-header border-0">
                <button type="button" className="btn-close" onClick={onClose}  aria-label="Close"></button>
            </div>
            <div className="modal-body text-center mb-5">
            <div className="popup-subhead">Sector Allocation</div>
            <div className="mb-0 popup-label">
              {/* <span className="popup-labels">Label:</span>  */}
              {data?.label}</div>
             <div className=" popup-label primary">
             {/* <span className="popup-labels">Value:</span> */}
             {data?.value}</div>
            </div>
        </div>
    </div>
</div>
</div>
  );
}
